$navigation-logo-focus-color: #d3d3d3 !default;

:host {
  display: block;
  height: 100%;

  *,
  :after,
  :before {
    box-sizing: border-box;
    outline: 0 none;
    text-rendering: optimizelegibility;
  }
}

.#{$prefix}logo-wrapper {
  position: relative;
  height: 100%;
  padding: 16px 16px 16px 16px;
  display: flex;
  align-items: center;

  a {
    display: flex;
    height: 100%;

    &:focus-visible {
      outline: $navigation-logo-focus-color solid 2px;
      outline-offset: 4px;
      border-radius: 2px;
    }
  }

  img {
    position: relative;
    display: block;
    align-self: center;
    max-height: 100%;
  }
}
